<div class="modal-header no-print" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">print</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Imprimir listagem</h2>
        <span class="modal-subtitle">{{ data.rotuloPeriodo }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content modal-print-container">
    @if (isCarregando) {
    <div class="no-print">
        <app-loading-box width="100%" height="280"></app-loading-box>
    </div>
    } @else {
    <!-- Cabeçalho DO PAPEL: na tela ele é redundante com o header do modal, mas a janela de
         impressão leva só este bloco, e sem ele a folha sairia sem dizer do que é. -->
    <div class="pv-print-cabecalho">
        <h3>Processo de Venda</h3>
        <div class="pv-print-subtitulo">
            {{ data.rotuloPeriodo }} · {{ totalRegistros }} documento(s) ·
            impresso em {{ impressoEm | date: 'dd/MM/yyyy HH:mm' }}
        </div>
    </div>

    @if (isTruncado) {
    <!-- Some no papel de propósito: é um aviso sobre a impressão, não um dado dela. -->
    <div class="pv-print-aviso no-print">
        <mat-icon class="material-symbols-outlined">warning</mat-icon>
        A listagem tem {{ totalRegistros }} documentos e a impressão traz os {{ tetoImpressao }} mais
        recentes. Reduza o período ou aplique mais filtros para imprimir tudo.
    </div>
    }

    @if (linhas.length === 0) {
    <p class="pv-print-vazio">Nenhum documento encontrado com os filtros atuais.</p>
    } @else {
    <table mat-table [dataSource]="linhas" class="pv-print-tabela">
        <ng-container matColumnDef="numero">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let linha">{{ numeroExibido(linha) }}</td>
        </ng-container>

        <ng-container matColumnDef="cliente">
            <th mat-header-cell *matHeaderCellDef>Cliente</th>
            <td mat-cell *matCellDef="let linha">
                {{ linha.documento.nomePessoaCliente ?? 'Cliente não informado' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="processo">
            <th mat-header-cell *matHeaderCellDef>Processo</th>
            <td mat-cell *matCellDef="let linha">{{ linha.nomeProcesso }}</td>
        </ng-container>

        <ng-container matColumnDef="etapa">
            <th mat-header-cell *matHeaderCellDef>Etapa atual</th>
            <td mat-cell *matCellDef="let linha">{{ linha.nomeEtapa }}</td>
        </ng-container>

        <ng-container matColumnDef="responsavel">
            <th mat-header-cell *matHeaderCellDef>Responsável</th>
            <td mat-cell *matCellDef="let linha">{{ linha.documento.nomeVendedor ?? '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="data">
            <th mat-header-cell *matHeaderCellDef>Data</th>
            <td mat-cell *matCellDef="let linha">
                @if (ehModelo(linha)) {
                    —
                } @else {
                    {{ linha.documento.dataEmissao | date: 'dd/MM/yyyy' }}
                }
            </td>
        </ng-container>

        <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef class="text-end">Valor (R$)</th>
            <td mat-cell *matCellDef="let linha" class="text-end">
                {{ linha.documento.valorTotal | abnt: 'preco' : 2 }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunas"></tr>
        <tr mat-row *matRowDef="let linha; columns: colunas"></tr>
    </table>

    <!-- Total do que foi impresso. Fora da tabela para não virar uma linha que o mat-table
         ordenaria ou paginaria junto com os documentos. -->
    <div class="pv-print-total">
        <span>Total impresso</span>
        <strong>{{ somaValorTotal | abnt: 'preco' : 2 }}</strong>
    </div>
    }
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="fechar()">Fechar</button>
    <button mat-flat-button class="btn-primary" [disabled]="isCarregando || linhas.length === 0" (click)="imprimir()">
        <mat-icon class="material-symbols-outlined">print</mat-icon>
        Imprimir
    </button>
</mat-dialog-actions>
